import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  errorBannerText: {
    description: 'Error message for notification that network request failed when attempting to modify tax information',
    defaultMessage: 'Unable to save changes. Please Cancel and try again.',
    id: '8bdomK',
  },
  editRecipientTaxIdentifierTitle: {
    description: 'Title for editing recipient tax identifier modal',
    defaultMessage: 'Edit Tax ID Details',
    id: 'bo0/TR',
  },
  addRecipientTaxIdentifierTitle: {
    description: 'Title for adding recipient tax identifier modal',
    defaultMessage: 'Add Tax ID Details',
    id: 'f/kiTY',
  },
  recipientTaxIdentifierInstructions: {
    description: 'Edit button for editing recipient tax identifier',
    defaultMessage:
      'Add up to 3 recipient tax identifiers for this shipment. You can copy the same tax identifiers to other shipments in the same order, if applicable. ',
    id: 'iVERib',
  },
  taxIdentifierNumber: {
    description: 'orderDetails.recipient.taxIdentifierNumber',
    defaultMessage: 'Tax ID Number',
    id: 'gFFC8g',
  },
  taxIdentifierType: {
    description: 'orderDetails.recipient.taxIdentifierType',
    defaultMessage: 'Tax ID Type',
    id: 'ZuDPhB',
  },
  editRecipientTaxIdentifierSaveButton: {
    description: 'orderDetails.recipient.saveBtn',
    defaultMessage: 'Save',
    id: 'UErP9V',
  },
  taxIdentifierTypeEmpty: {
    defaultMessage: 'Select Type',
    id: 'rY7nHA',
    description: 'tax id dropdown empty state',
  },
  taxIdentifierNumberPlaceholder: {
    defaultMessage: 'Enter Tax identifier number',
    id: 'Ci4FEn',
    description: 'tax id number input placeholder',
  },
  editRecipientTaxIdentifierClearButton: {
    description: 'link button that clears the tax identifier',
    defaultMessage: 'Clear',
    id: 'pSTOxo',
  },
  taxIdentifierAddButton: {
    defaultMessage: 'Add Tax ID Type',
    id: 'EU9lwR',
    description: 'Button to add a new Tax identifier',
  },
  bulkUpdateAllShipments: {
    defaultMessage: 'Apply to all open shipments in this order',
    description: 'label for a checkbox that when clicked will "bulk update" all shipments',
    id: 'WZdjfL',
  },
});

export const validationErrorMessages = defineMessages({
  taxNumber: {
    description: 'Required validation error message for TAX_NUMBER',
    defaultMessage: 'Tax Number is Required',
    id: 'E27X5V',
  },
  type: {
    description: 'Required validation error message for TYPE',
    defaultMessage: 'Type is Required',
    id: '3Zr2kJ',
  },
});
